import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { NotFoundComponent } from './shared/modules/not-found/components/not-found.component';
import { UserContextGuard } from './shared/guards/user-context.guard';
import { PATH } from './shared/types/enums/path';
import { AuthGuard } from '@auth0/auth0-angular';
import { HasScopesGuard } from './shared/guards/has-scopes.guard';
import { MonitoringResolver } from './shared/handlers/monitoring-resolver.resolver';

const routes: Routes = [
  { path: PATH.EMPTY, redirectTo: PATH.AUTH, pathMatch: 'full' },
  {
    path: PATH.AUTH,
    loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule),
    resolve: {
      monitoring: MonitoringResolver,
    },
  },
  {
    path: PATH.ROOT,
    canActivate: [AuthGuard, UserContextGuard],
    loadChildren: () => import('./modules/root/root.module').then(m => m.RootModule),
    resolve: {
      monitoring: MonitoringResolver,
    },
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
